module.exports = __webpack_public_path__ + "static/img/dcdd.b1ef78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dcdd.jpg
// module id = PfOl
// module chunks = 4